<template>
	<section class="d-flex flex-column h-full"> 
		<main class="bg-documentGray mdc-top-app-bar--fixed-adjust flex-grow-1 board_module view" :class="comments=='' ? 'main-height' : ''">
			
			<div class="t-body3 font-r t-color-bodyGrayB pdt-24 pdb-24 t-center" v-if="comments==''">
				{{$t('3132')}}<br>{{$t('3133')}}
				</div>
			<div class="pdt-16 pdl-16 pdr-16 bg-documentGray" v-if="comments && comments.length>0" :style="form.images.length >0 ? 'padding-bottom: 130px':'padding-bottom: 14px'">
				<div class="d-flex" v-for="comment in comments" :key="comment.id">
					<div class="list-image-small" v-if="comment && comment.auditor && comment.auditor.register && comment.auditor.register.profile">
						<img v-if="comment && comment.auditor && comment.auditor.register" :src="comment && comment.auditor && comment.auditor.register && comment.auditor.register.profile? comment.auditor.register.profile:'/images/board/user-icon.png'" class="circle w-40 min-w-40 h-40" :alt="comment && comment.auditor && comment.auditor.register?comment.auditor.register.name.fullName:''">
					</div>
					<div v-else v-html="firstCharOfNames" :style="bgColorOfName" class="list-image-small circle w-40 min-w-40 h-40 user-name-profile">
					</div>
					<div class="flex-grow-1 pdl-16">
						<div class="d-flex">
							<div class="flex-grow-1">
								<div class="t-body3 mgb-1 font-r">{{ comment && comment.auditor && comment.auditor.register && comment.auditor.register.name ? $t('3437',{first: comment.auditor.register.name.first, last: comment.auditor.register.name.last}):''}}</div>
								<div class="t-body3  t-color-bodyGrayA mgr-8">{{ $moment(comment.auditor.register.time).format("L") }} </div>
							</div>
							<div class="more-btn-parent-div position-relative"><i class="material-icons t-color-iconInactive t-headline14 more_btn" @click="toggleMore" tabindex="0">more_horiz</i>
								
								<div class="more_box box-absolute position-absolute" style="display:none">
									
									<a
									class="cursor-pointer"
									v-if="!comment.owner"
									@click="reportComment(comment.id, comment.report)" @keypress="reportComment(comment.id, comment.report)" tabindex="0"
									>{{ $t("3136") }}</a>
									<a
									class="cursor-pointer"
									v-if="comment.owner"
									@click="editCommentSet(comment,$event)" @keypress="editCommentSet(comment,$event)" tabindex="0"
									>{{ $t("3137") }}</a>
									
									<a
									class="cursor-pointer"
									v-if="comment.owner"
									@click="deleteComment(comment.id,0,$event)" @keypress="deleteComment(comment.id,0,$event)" tabindex="0"
									>{{ $t("3138") }}</a>
								</div>
								
							</div>
						</div>
						<div class="mgt-16 t-color-bodyGrayA t-body3 " v-html="comment.contents">
						</div>
						<div class="scroll-x scroll-view">
							<div class="d-flex mgt-8 comment-attachment  fixed-width" v-if="comment && comment.images && comment.images.length">
							<a class="grid-3-item position-relative mgr-8" v-for="(img, i) in comment.images" :key="i" @click="fileDisply(img)" @keypress="fileDisply(img)" tabindex="0">
								<img tabindex="0" @click="fileDisply(img.resourceUri,false)" @keypress="fileDisply(img.resourceUri,false)" v-if="getType(img.contentType) === 'image'" :src="img.resourceUri" :alt="img.originalName" />
								<video-player
									class="video-player-box comment-video"
									v-if="getType(img.contentType) === 'video'"
									ref="videoPlayer"
									:options="getPayerOption(img)"
									:playsinline="true"
									customEventName="customstatechangedeventname"
								/>
								<div style="position:absolute; background-color:transparent; width:80px;height:80px; margin-top: 80px;z-index:999"></div>
							</a>
						</div>
						</div>
					   <!-- <div class="t-helper t-color-iconInactive pdt-8 pdb-16 font-r"  @click="toggleReply(comment.id,comment.auditor.register.name.fullName)" v-if="selectedChild && selectedChild.register === true" >{{$t('3135')}} </div> -->
					   <div class="t-helper t-color-iconInactive pdt-8 pdb-16 font-r"  @click="toggleReply(comment.id,comment.auditor.register.name.fullName)" @keypress="toggleReply(comment.id,comment.auditor.register.name.fullName)" tabindex="0">{{$t('3135')}} </div>
					   <input type="hidden" id="replyCommentId" />         
					   <div class="d-grid flex-column d-none" :id="`commentInput_${comment.id}`">
						</div>
						<div class="pdb-16"  v-for="reply in comment.children" :key="reply.id">
							<div class="d-flex">
								<div class="list-image-small" v-if="reply && reply.auditor && reply.auditor.register && reply.auditor.register.profile">
									<img :src="reply && reply.auditor && reply.auditor.register && reply.auditor.register.profile? reply.auditor.register.profile:'/images/board/user-icon.png'" class="circle w-28 min-w-28 h-28" :alt="reply.auditor.register.name.fullName">
								</div>
								<div class="list-image-small user_img w-28 min-w-28 h-28 user-name-profile reply" v-else v-html="firstCharOfNames" :style="bgColorOfName">
								</div>
								<div class="flex-grow-1 pdl-16">
									<div class="d-flex">
										<div class="flex-grow-1">
											<div class="t-body3 mgb-1 font-r">{{ reply.auditor.register.name?$t('3437',{first: reply.auditor.register.name.first, last: reply.auditor.register.name.last}):'' }}</div>
											<div class="t-body3 t-color-bodyGrayA mgr-8">{{ $moment(reply.auditor.register.time).format("L") }} </div>
										</div>
										<div class="more-btn-parent-div position-relative"><i tabindex="0" class="material-icons t-color-iconInactive t-headline14 more_btn" @click="toggleMore" v-if="!reply.owner || (selectedChild && selectedChild.modify === true) ||  (selectedChild && selectedChild.remove === true) ">more_horiz</i>
											<div class="more_box box-absolute position-absolute" style="display:none">
											<a
											class="cursor-pointer"
											v-if="!reply.owner"
											@click="reportComment(reply.id, reply.report)" @keypress="reportComment(reply.id, reply.report)" tabindex="0"
											>{{ $t("3136") }}</a>
											<a
											class="cursor-pointer"
											v-if="reply.owner"
											@click="editReplySet(reply,comment.id,$event,comment.auditor.register.name.fullName)" @keypress="editReplySet(reply,comment.id,$event,comment.auditor.register.name.fullName)" tabindex="0"
											>{{ $t("3137") }}</a>
											
											<a
											class="cursor-pointer"
											v-if="reply.owner"
											@click="deleteComment(reply.id,comment.id,$event)" @keypress="deleteComment(reply.id,comment.id,$event)" tabindex="0"
											>{{ $t("3138") }}</a>
											</div>
										</div>
									</div>
									<div class="mgt-16 t-color-bodyGrayA t-body3 " v-html="reply.contents">
									</div>
									<div class="scroll-x scroll-view-reply">
										<div class="d-flex mgt-8 comment-attachment reply-comment-img fixed-width" v-if="reply && reply.images && reply.images.length">
										<div class="grid-3-item position-relative" v-for="(img, l) in reply.images" :key="l" @click="fileDisply(img)" @keypress="fileDisply(img)" tabindex="0">
										<img  v-if="getType(img.contentType) === 'image'" :src="img.resourceUri" :alt="img.originalName">
										<video-player
											class="video-player-box comment-video"
											v-if="getType(img.contentType) === 'video'"
											:options="getPayerOption(img)"
											:playsinline="true"
										/>
										<div style="position:absolute; background-color:transparent; width:80px;height:80px; top: 0;z-index:999"></div>
										</div>
									</div>
									</div>
								   

								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
			
			
			<!-- <div  class="pdt-16 pdl-16 pdr-16 bg-documentGray" v-if="comments && comments.length>0">
			<div class="d-flex">
				<div class="list-image-small">
					<img src="/images/checklist/checklist-user.png" alt="CLPtester" class="circle w-40 min-w-40 h-40">
				</div>
				<div class="flex-grow-1 pdl-16">
					<div class="d-flex">
						<div  class="flex-grow-1">
							<div  class="t-body3 mgb-1 font-r">김길동</div>
							<div  class="t-body3  t-color-bodyGrayA mgr-8">2019. 09. 11 </div>
						</div>
						<div class="d-flex  mgb--1">
							
							<div class="position-relative p-0">
								<div class="d-flex align-items-center justify-content-end">
									
									<div class="pdl-8 position-relative mdc-menu-anchor menu-container">
										<button type="button" class="mdc-icon-button js--dropdown-toggle pda-0 w-24 h-24">
											<div class="mdc-button__ripple"></div>
											<i class="material-icons t-color-iconInactive">more_horiz</i>
										</button>
									
										<div class="mdc-menu mdc-menu-surface toggle-menu edm-toggle">
											<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical"
												tabindex="-1">
												<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem">
													<span class="mdc-list-item__ripple"></span>
													<span class="mdc-list-item__text t-body6 font-r t-color-headlineBlack">신고하기</span>
												</li>
												<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem">
													<span class="mdc-list-item__ripple"></span>
													<span class="mdc-list-item__text t-body6 font-r t-color-bodyGrayA">최근 입고순</span>
												</li>
												
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div  class="mgt-16 t-color-bodyGrayA t-body3 font-r l-spacing42">네트워킹은 자신의 경력을 관리하는 데 도움이 되는 기본적인 기술입니다.</div>
					<div  class="scroll-x scroll-view">
						<div  class="d-flex mgt-8 comment-attachment  fixed-width">
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
						</div>
					</div>
					<div  class="t-helper t-color-iconInactive pdt-16 pdb-13 font-r">답글 달기</div>
					<div  class="pdt-16">
					   <div class="d-flex">
						<div class="list-image-small">
							<img src="/images/checklist/checklist-user.png" alt="CLPtester" class="circle w-28 min-w-28 h-28">
						</div>
						<div  class="flex-grow-1 pdl-16">
							<div  class="d-flex">
								<div  class="flex-grow-1">
									<div  class="t-body3 mgb-1 font-r">김길동</div>
									<div  class="t-body3  t-color-bodyGrayA mgr-8">2019. 09. 11 </div>
								</div>
								<div class="d-flex  mgb--1">
									
									<div class="position-relative p-0">
										<div class="d-flex align-items-center justify-content-end">
											
											<div class="pdl-8 position-relative mdc-menu-anchor menu-container">
												<button type="button" class="mdc-icon-button js--dropdown-toggle pda-0 w-24 h-24">
													<div class="mdc-button__ripple"></div>
													<i class="material-icons t-color-iconInactive">more_horiz</i>
												</button>
											
												<div class="mdc-menu mdc-menu-surface toggle-menu edm-toggle">
													<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical"
														tabindex="-1">
														<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem">
															<span class="mdc-list-item__ripple"></span>
															<span class="mdc-list-item__text t-body6 font-r t-color-headlineBlack">신고하기</span>
														</li>
														
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div  class="mgt-16 t-color-bodyGrayA t-body3 font-r l-spacing42">네트워킹은 자신의 경력을 관리하는 데 도움이 되는 기본적인 기술입니다.</div>
					<div  class="scroll-x scroll-view">
						<div  class="d-flex mgt-8 comment-attachment  fixed-width">
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
							<a  class="grid-3-item position-relative mgr-8">
								<img  src="/images/checklist/edm-list-icon.png" >
								<div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								</div>
							</a>
		  
						</div>
					</div>
					<div  class="t-helper t-color-iconInactive pdt-16 pdb-16 font-r">답글 달기</div>
						</div>
					   </div>
					</div>
					<div  class="pdt-16">
						<div class="d-flex">
						 <div class="list-image-small">
							 <img src="/images/checklist/checklist-user.png" alt="CLPtester" class="circle w-28 min-w-28 h-28">
						 </div>
						 <div  class="flex-grow-1 pdl-16">
							 <div  class="d-flex">
								 <div  class="flex-grow-1">
									 <div  class="t-body3 mgb-1 font-r">김길동</div>
									 <div  class="t-body3  t-color-bodyGrayA mgr-8">2019. 09. 11 </div>
								 </div>
								 <div class="d-flex  mgb--1">
									 
									 <div class="position-relative p-0">
										 <div class="d-flex align-items-center justify-content-end">
											 
											 <div class="pdl-8 position-relative mdc-menu-anchor menu-container">
												 <button type="button" class="mdc-icon-button js--dropdown-toggle pda-0 w-24 h-24">
													 <div class="mdc-button__ripple"></div>
													 <i class="material-icons t-color-iconInactive">more_horiz</i>
												 </button>
											 
												 <div class="mdc-menu mdc-menu-surface toggle-menu edm-toggle">
													 <ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical"
														 tabindex="-1">
														 <li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem">
															 <span class="mdc-list-item__ripple"></span>
															 <span class="mdc-list-item__text t-body6 font-r t-color-headlineBlack">신고하기</span>
														 </li>
														 <li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem">
															 <span class="mdc-list-item__ripple"></span>
															 <span class="mdc-list-item__text t-body6 font-r t-color-bodyGrayA">삭제하기</span>
														 </li>
														 
													 </ul>
												 </div>
											 </div>
										 </div>
									 </div>
								 </div>
							 </div>
							 <div  class="mgt-16 t-color-bodyGrayA t-body3 font-r l-spacing42">네트워킹은 자신의 경력을 관리하는 데 도움이 되는 기본적인 기술입니다.</div>
					 <div  class="scroll-x scroll-view">
						 <div  class="d-flex mgt-8 comment-attachment  fixed-width">
							 <a  class="grid-3-item position-relative mgr-8">
								 <img  src="/images/checklist/edm-list-icon.png" >
								 <div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								 </div>
							 </a>
							 <a  class="grid-3-item position-relative mgr-8">
								 <img  src="/images/checklist/edm-list-icon.png" >
								 <div  style="position: absolute; background-color: transparent; width: 80px; height: 80px; margin-top: 80px; z-index: 999;">
								 </div>
							 </a>
		   
						 </div>
					 </div>
					 <div  class="t-helper t-color-iconInactive pdt-16 pdb-16 font-r">답글 달기</div>
						 </div>
						</div>
					</div>
				</div>
			</div>
			</div>

		<div  class="textBlock w-full bg-white footer fixed-bottom-footer">
			<div  class="divider"></div>
			<div  class="position-relative d-flex pdt-16 pdb-16 pdl-16 pdr-16 align-items-start">
				<div class="t-body3 t-color-linkBlue font-r bg-linkBg mention-text-area mgr-8 t-nowrap position-absolute">@CLPtester<span class="cursor-pointer t-color-iconInactive pdl-8 pdr-4 mgr-8">x</span></div>
				
				<textarea  placeholder="내용을 입력하세요" id="comment_textarea" class="cursor-blue  comment_textarea mdc-text-field__input t-body3 border-none t-color-headlineBlack p-0 font-r l-spacing42 text-indent-112" >내용이 입력될때 색상이 바뀝니다.
니다. 네트워킹은 자신의 경력을 관리하는 데 도움이 되는 기본입니다.</textarea>
            </div>
            <div  class="attachedFileContainer scroll-x">
                <div  class="post-video position-relative pdr-22 attach-video">
                    <img  src="/images/checklist/edm-list-icon.png" alt="image-placeholder-big.png">
                    <span  class="remove-img remove-image-new position-absolute t-color-white">
                        <img  src="/images/checklist/close.svg" class="w-20 h-20">
                    </span>
                </div>
                <div  class="post-video position-relative pdr-22 attach-video">
                    <img  src="/images/checklist/edm-list-icon.png" alt="image-placeholder-big.png">
                    <span  class="remove-img remove-image-new position-absolute t-color-white">
                        <img  src="/images/checklist/close.svg" class="w-20 h-20">
                    </span>
                </div>
                <div  class="post-video position-relative pdr-22 attach-video">
                    <img  src="/images/checklist/edm-list-icon.png" alt="image-placeholder-big.png">
                    <span  class="remove-img remove-image-new position-absolute t-color-white">
                        <img  src="/images/checklist/close.svg" class="w-20 h-20">
                    </span>
                </div>
                <div  class="post-video position-relative pdr-22 attach-video">
                    <img  src="/images/checklist/edm-list-icon.png" alt="image-placeholder-big.png">
                    <span  class="remove-img remove-image-new position-absolute t-color-white">
                        <img  src="/images/checklist/close.svg" class="w-20 h-20">
                    </span>
                </div>
                <div  class="post-video position-relative pdr-22 attach-video">
                    <img  src="/images/checklist/edm-list-icon.png" alt="image-placeholder-big.png">
                    <span  class="remove-img remove-image-new position-absolute t-color-white">
                        <img  src="/images/checklist/close.svg" class="w-20 h-20">
                    </span>
                </div>
            </div>
        </div> -->
            
            <div class="divider" v-if="currentPage<totalPages"></div>
            <div class="bg-documentGray"><button type="button" v-if="currentPage<totalPages" class="btn btn-secondary w-full pdt-10 pdb-10" @click="getComments" @keypress="getComments" tabindex="0">{{$t('3093')}} </button></div>
        </main>
        
        <div class="textBlock w-full bg-white fixed-bottom-footer">
            <div class="divider"></div>
            <div class="position-relative d-flex pdt-16 pdb-16 pdl-16 pdr-16">
                        <div class="t-body3 t-color-linkBlue font-r bg-linkBg mention-text-area mgr-8" v-if="userName">@{{userName}}<span class="cursor-pointer t-color-iconInactive pdl-8 pdr-4 mgr-8" @click="toggleReply" @keypress="toggleReply" tabindex="0">x</span></div>
                          <textarea
                              @keyup="resizeIt($event.target.value)"
                              @click="setActive" @keypress="setActive" tabindex="0"
                              class="cursor-blue h-24 comment_textarea mdc-text-field__input t-body3 border-none t-color-headlineBlack p-0  "
                              :class="{'commentInvaliderror':commentValid}"
                              v-model="form.contents"
                              :placeholder="$t('3134')"
                              id="comment_textarea"
                            >
                          </textarea>
                        </div>
            <div class="attachedFileContainer scroll-x"   v-if="form.images.length >0" >
                    
                          <div class="post-video position-relative pdr-22 attach-video" v-for="(img, i) in form.images" :key="i" >
                            <img :src="img.resourceUri" :alt="img.originalName"  v-if="getType(img.contentType) == 'image' " />
                            <video-player
                            v-if="getType(img.contentType) == 'video'"
                            class="video-player-box  attach-video"
                            :options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: img.contentType, src: img.resourceUri }], height: 100, width:100}"
                            :playsinline="true"
                          />
                            <span @click="form.images.splice(i, 1)" @keypress="form.images.splice(i, 1)" class="remove-img remove-image-new position-absolute t-color-white" tabindex="0"><img src="/images/close.svg" class="w-20 h-20" /></span>
                          </div>
            </div>
           <div class="pdb-34">
                <div class="d-flex justify-content-between pda-4">
                <div class="d-flex">
                    <input
                    type="file"
                    id="commentFileUpload"
                    accept="image/jpeg, image/png, video/mp4"
                    @change="uploadFile"
                    class="d-none"
                  />
                    <button class="material-icons mdc-icon-button t-color-textfieldGuid"  @click="openFileUpload(true)" @keypress="openFileUpload(true)" tabindex="0">collections</button>
                    <!-- <button class="material-icons mdc-icon-button t-color-textfieldGuid"  @click="openFileUpload(true)">videocam</button> -->
                    
                </div>
               
                
                <button
                    class="mdc-icon-button  sendMessageBtn t-color-white align-items-center justify-content-between" :class="{'on':coomentActiveButton}" @click="submitComment" @keypress="submitComment" tabindex="0"><i
                        class="material-icons  min-w-24 min-h-24">arrow_upward</i></button>
            </div>
           </div>
        </div>
        <div class="backlayer"></div>
    </section>
</template>

<script>
import {MDCMenu} from '@material/menu';
import boardApi from '@/api/boardApi.js'
import checklistApi from '@/api/checklistApi.js'
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

export default {
	data() {
		return {
			menuBar: null,
			headerName: null,
			userAuthData: null,
			detail: null,
			isComment: true,
			comments: [],
			coomentActiveButton:false,
			commentValid:false,
			commentEdit:false,
			commentEditId:null,
			selectedChild:null,
			mamberData: [],
			form: {
				contents: null,
				images: [],
			},
			replyImg: [],
			currentPage: 1,
			totalPages: 1,
			b :true,
			userName: '',
			evtReply:{},
			commentBottom: true,
			firstCharOfNames : localStorage.getItem('firstChar'),
			bgColorOfName : localStorage.getItem('bgColors'),
			//fieldData:null
			backFixLayer:false
		}
	},

	components: {
		videoPlayer,
	},

	watch: {
		$route(to, from) {
			//this.userAuth();
			this.getComments();
		}
	},
	
	mounted() {
		// let boardName =  this.$route.query.boardName.replace('-','&')
		// this.headerName= boardName
		const menuEls = Array.from(document.querySelectorAll('.mdc-menu'));
		menuEls.forEach((menuEl) => {
			this.menuBar = new MDCMenu(menuEl);
			const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
			dropdownToggle.addEventListener('click', () => {
				this.menuBar.open = !this.menuBar.open;
			});
		});
		

		this.getComments();
	},

	methods: {

		//Alert box report
		askForReport(status) {
			if (status) return;
			this.$confirm({
				content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
				accept: this.$t("1451"), // 확인
				cancel: this.$t("1447"), //'TODO-취소'
			}).then(() => {
				this.reportPost();
			}).catch(() => {});
		},

		//Alert box delete
		askForDelete() {
			this.$confirm({
				content: this.$t("1877"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
				accept: this.$t("1879"), // 확인
				cancel: this.$t("1878"), //'TODO-취소'
			}).then(() => {
				this.deletePost();
			}).catch(() => {});
		},

		//Generate Report by loggedIn user
		reportPost() {
			this.$showLoading();
				checklistApi.reportPost(this.$route.params).then((response) => {
					this.$hideLoading();
					this.detail.report = true;
				}).catch((err) => {
					this.$hideLoading();
					this.$error({ content: err.errMsg }).then(() => {});
				});
		},

		//Delete post by loggedIn user
		deletePost() {
			this.$showLoading();
				checklistApi.deletePost(this.$route.params).then((response) => {
					this.$hideLoading();
					this.goToPrevious()
					//this.$router.push('/socialLearning?board='+this.boardId+'&boardName='+encodeURI(this.boardName))
				}).catch((err) => {
					this.$hideLoading();
					this.$error({ content: err.errMsg }).then(() => {});
				});
		},

		// getDetail() {
		//     this.$showLoading();
		//     checklistApi.boardDetails(this.$route.params).then((response) => {
		//         this.detail = response.data.data;
		//         console.log('this.detail=>',this.detail)
		//         this.$hideLoading();
		//     }).catch((err) => {
		//         this.$hideLoading();
		//         this.$error({ content: err.errMsg }).then(() => {});
		//     });
		// },

		listFilter(str){
			
			// if (str) {
			//     let str2 =str.replace(/<a [^>]+>[^<]*<\/a>/, '')
			//     let strRemoveRNTags = str2.replace(/(\r\n|\n|\r)/gm, '');
			//     return strRemoveRNTags
			// } 
		},

		// Comment list
		getComments() {
			let responseData = null;
			let params = this.setParams();
				checklistApi.listComments(this.$route.params,params).then((response) => {
					responseData = response.data.data;
					this.comments = this.comments.concat(responseData.content);
				//this.comments = responseData.content;
					this.currentPage++;
					this.totalPages = responseData.totalPages;

					if (this.bottomVisible()) {
						this.getComments()
					}
				})
				.catch((err) => {
				});
			},

		setParams() {
			let params = {
				page:this.currentPage,
				size: 10,
			};
			return params;
		},

		// Preview of image and video
		fileDisply(data) {
			localStorage.setItem("socialFile", JSON.stringify(data));
			this.$router.push({
				name: 'PerviewFile',
				params: this.$route.params,
				query: this.$route.query
			})
		},

		getWHieght(){
		  return $(window).width();
		},

		uploadFile(evt) {
			if (!evt.target.files[0]) return;
			if (!this.invalidCountImg()) return;

			this.$showLoading();
			checklistApi.upload(evt.target.files[0]).then((response) => {
				// check if Image need to add into reply or comment
				if (this.isComment) this.form.images.push(response.data.data[0]);
				else this.replyImg.push(response.data.data[0]);

				this.$hideLoading();
			}).catch((err) => {
					this.$hideLoading();
					this.$error({ content: err.errMsg }).then(() => {});
			});
		},
		// check if image selected then count number of image selected
		invalidCountImg() {
			if (this.isComment && this.form.images.length >= 5) {
				this.$alert({
					content: this.$t("1469"),
					accept: this.$t("1470")
				});
				return false;
			} else {
				if(this.replyImg.length >= 5) {
					this.$alert({
						content: this.$t("1469"),
						accept: this.$t("1470")
					});
					return false;
				}
				
			}
			return true;
		},

		openFileUpload(status) {
			this.isComment = status;
			document.getElementById("commentFileUpload").click();
		},

		resetVideo() {
			this.form.images = Array();
		},

		getPayerOption(img) {
			return {
				muted: true,
				language: "en",
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [
				{
					type: img.contentType,
					src: img.resourceUri,
				},
				],
				height: 80,
				width: 80,
			};
		},

		getType(contentType) {
			return contentType.split("/")[0];
		},

		resizeIt(str) {
			var elmnt = document.getElementById("comment_textarea");
			elmnt.style.height = 0;
			var scHeight = elmnt.scrollHeight;
			elmnt.style.height = scHeight+"px";
		},

		setActive(){
			this.coomentActiveButton = true;
		},

		// Submit Comment
		submitComment() {
			if(this.b===true) {
				if((this.form.contents && this.form.contents.length > 0) || (this.form && this.form.images.length > 0)){
					this.commentValid = false;
					//this.userAuth();
					this.$showLoading();
					if(this.commentEdit){
							checklistApi.commentEdit(this.$route.params, this.form,this.commentEditId).then((resp) => {
							// reset comment form
							this.resetCommentForm();
							//this.comments.push(resp.data.data);
							let commentIndex = this.comments.findIndex((el) => el.id == resp.data.data.id);
							this.comments[commentIndex] = resp.data.data;
							this.commentEdit = false;
							//this.detail.commentCount = this.detail.commentCount + 1;
							this.$hideLoading();
						}).catch((err) => {
							this.$error({ content: err.errMsg }).then(() => {});
						});
					}else{
						//console.log('boare auth data submitComment=>view',this.userAuthData);
						//if(this.userAuthData.userCommToDayAuth){
							checklistApi.commentPost(this.$route.params, this.form).then((resp) => {
								// reset comment form
								this.resetCommentForm();
								
								this.comments.push(resp.data.data);
								
								//this.detail.commentCount = this.detail.commentCount + 1;
								//this.SET_VIEW({id:this.detail.id,viewCount:this.detail.viewCount,commentCount:this.detail.commentCount });
								this.$hideLoading();
							})
							.catch((err) => {
							this.$error({ content: err.errMsg }).then(() => {});
							});
						// }else{
						//     this.$hideLoading();
						//     this.$snackOpen({contents: this.$t('3064'), btnDisplayYN: false}).then(() => {})
							
						// }
					}
		
				}else{
					this.commentValid = true;
				}

			} else {
				let commentId =  document.getElementById('replyCommentId').value;
				this.submitReply(commentId)
			}
			// if (!this.detail) return;
			//     if(this.form.contents && this.form.contents.length > 0){
			//         this.commentValid = false;
			//         this.userAuth();
			//         this.$showLoading();
			//         if(this.commentEdit){
			//                 boardApi.commentEdit(this.$route.params, this.form,this.commentEditId).then((resp) => {
			//                 this.resetCommentForm();
			//                 let commentIndex = this.comments.findIndex((el) => el.id == resp.data.data.id);
			//                 console.log('commentIndex',commentIndex)
			//                 this.comments[commentIndex] = resp.data.data;
			//                 this.commentEdit = false;
			//                 this.$hideLoading();
			//             }).catch((err) => {
			//                 this.$error({ content: err.errMsg }).then(() => {});
			//             });
			//         }else{
			//             console.log('boare auth data submitComment=>view',this.userAuthData);
			//             if(this.userAuthData.userCommToDayAuth){
			//                 boardApi.commentPost(this.$route.params, this.form).then((resp) => {
			//                     this.resetCommentForm();

			//                     this.comments.push(resp.data.data);
			//                     this.detail.commentCount = this.detail.commentCount + 1;
			//                     this.$hideLoading();
			//                 })
			//                 .catch((err) => {
			//                 this.$error({ content: err.errMsg }).then(() => {});
			//                 });
			//             }else{
			//                 this.$hideLoading();
			//                 this.$snackOpen({contents: this.$t('3064'), btnDisplayYN: false}).then(() => {})
			//             }
			//         }
		
			//     }else{
			//         this.commentValid = true;
			//     }
		},

		// Empty Comment Textarea after submit
		resetCommentForm() {
			this.form = {
				contents: null,
				images: [],
			};
			
		},
	   
		// Open menu report,modify and delete
		toggleMore(evt) {
			let field = evt.target.closest(".more-btn-parent-div").querySelector(".more_box");
			const backLayer = document.querySelector('.backlayer');
			backLayer.style.display = "block";
			// console.log('toggleMore=>=>=>',evt.target.closest(".more-btn-parent-div"))
			// this.fieldData = field
			if (field.style.display === "none") {
				field.style.display = "block";
				this.backFixLayer = true
				 if(this.backFixLayer === true){
				// console.log('test2', this.backFixLayer)
					
					backLayer.addEventListener('click', ()=>{
						// console.log('test3', this.backFixLayer)
					field.style.display = "none";
					backLayer.style.display = "none";
					this.backFixLayer = false;
					})
				}
			} else {
				//this.resetCommentForm();
				field.style.display = "none";
				this.backFixLayer = false
			}
		},

		reportComment(id, status) {
			if (status) return;
			this.$showLoading();
			this.$confirm({
				content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
				accept: this.$t("1451"), // 확인
				cancel: this.$t("1447"), //'TODO-취소'
			}).then(() => {
				checklistApi.reportComment(this.$route.params, id).then((response) => {
					this.$hideLoading();
					if(response.status==200) {
						for (let c in this.comments) {
							if (this.comments[c].id == id) {
								this.comments[c].report = true;
								return;
							}
						}
					}
					
				}).catch((err) => {
					this.$error({ content: err.errMsg }).then(() => {});
				});
			}).catch(() => {
				this.$hideLoading();
				 $('.more_box').css('display', 'none');
			});
				
		},

		deleteComment(id,pid,evt) {
			// console.log(id,pid,evt)
			// this.toggleMore(evt)
			this.$showLoading();
				checklistApi.deleteComment(this.$route.params, id).then((response) => {
				this.$hideLoading();
			//	console.log(this.detail, this.comments)
				if(pid>0){
					for (let c in this.comments) {
					if (this.comments[c].id == pid) {
						for (let r in this.comments[c].children) {
						if (this.comments[c].children[r].id == id) {
							this.comments[c].children.splice(r, 1);
							return;
						}
						}
						return;
					}
					}
				}else{
					for (let c in this.comments) {
					if (this.comments[c].id == id) {
						this.comments.splice(c, 1);
						return;
					}
					}
				}
			//	this.$emit('getDetail');

			}).catch((err) => {
				this.$error({ content: err.errMsg }).then(() => {});
			});
		},

		editCommentSet(comment,evt){
			this.commentBottom = true;
			this.userName ='';
			this.replyEditId ='';
			this.replyEdit      = false;
			this.form.contents = comment.contents;
			this.form.images   =  comment.images;
			this.commentEditId = comment.id;
			this.commentEdit = true;
			this.toggleMore(evt)
		},

		// Edit Reply Textarea
		editReplySet(reply,cid,evt,userId){
			this.commentEditId='';
			this.commentEdit = false;
			this.commentBottom = false;
			this.form.contents  = reply.contents;
			this.form.images    = reply.images;
			this.replyEditId    = reply.id;
			this.replyEdit      = true;
			
			// this.replyImg       =   reply.images;
			// this.replyEditId    =   reply.id;
			// this.replyEdit      =   true;
			// $('#reply_text'+cid).val(reply.contents);
			this.toggleMore(evt)
			this.toggleReply(cid,userId)
		},
		
		// Reply button
		toggleReply(commentId,userId) {
			this.commentBottom=false
			this.userName = userId
			this.b = !this.b;
			let comeId= document.getElementById('replyCommentId').value = commentId
			if(comeId && this.b===false) {
				this.userName
			} else {
				this.userName = ''
			}
			document.getElementById(`commentInput_${commentId}`).classList.toggle("d-none");
		},

		// Submit Reply comment
		submitReply(originId) {
				this.$showLoading();
					if(!this.replyEdit){
						//if(this.userAuthData.userCommToDayAuth){
						// call API to add reply
							checklistApi.postReply(this.$route.params, originId, this.form).then((response) => { 
								this.$hideLoading();
								//evt.target.closest(".reply_area").querySelector(".comment_textarea").value = null;
								this.resetCommentForm();
								this.toggleReply(originId);
								this.replyImg = [];
								//this.getDetail();
								this.getComments();
								this.userName='';
								// add reply into parent
								for (let c in this.comments) {
									if (this.comments[c].id == originId) {
									this.comments[c].children.push(response.data.data);
									}
								}
							}).catch((err) => {
								this.$error({ content: err.errMsg }).then(() => {});
							});
					} else {
						checklistApi.editReply(this.$route.params,this.replyEditId, this.form).then((response) => {
							this.$hideLoading();
							//evt.target.closest(".reply_area").querySelector(".comment_textarea").value = null;
							this.resetCommentForm();
							this.toggleReply(originId);
							this.replyImg = [];
							this.replyEdit = false;
							this.getComments();
							this.userName='';
							// add reply into parent
							for (let c in this.comments) {
								if (this.comments[c].id == originId) {
									let replyIndex = this.comments[c].children.findIndex(arr=>arr.id==this.replyEditId);
									this.comments[c].children[replyIndex] = response.data.data;
									this.replyEditId = null;
									
								}
							}
						}).catch((err) => {
							this.$error({ content: err.errMsg }).then(() => {});
						});

					}
		},
		askForModify() {
			this.$router.push({
				name: 'BoardModify',
				params: {boardId:this.$route.params.boardId,postId:this.$route.params.postId},
				query: this.$route.query
			})
		},

		goToPrevious() {
			if(this.$route.query && this.$route.query.fromPage=='main') {
				this.$router.push('/home')
			} else {
				this.$router.push('/board/'+this.$route.params.boardId+'?boardName='+encodeURI(this.$route.query.boardName)+'&categoryName='+encodeURI(this.$route.query.categoryName))
			}
		}
		
	}
}
</script>
<style scoped>

	
</style>